import React, { Component } from 'react'
import { Formik } from 'formik'
import styled from 'styled-components'
import CreditCardFields from './../form-components/credit-card-fields/credit-card-fields.component'
import Button from '../buttons/buttons.component'
import Modal from '../modal/modal.component'
import Yup from '../../helpers/custom-yup'
import { CheckboxToggleInput } from '../form-components/inputs.component'
import { CreditCardService } from './../../services/credit-card.service'
import cardBrand from '../../constants/card-brand.constants';

const ButtonContainerStyled = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 15px;
`

class AddCardModalComponent extends Component {
	onSubmit = values => {
		const { onClose, onSubmit } = this.props

		CreditCardService.addCard(values).then(({ success, errors }) => {
			onClose({ success, errors })
			onSubmit()
		})
	}

	render() {
		const { isOpen, onClose } = this.props

		return (
			<Modal isOpen={isOpen} title="Adicionar novo cartão" onClose={onClose}>
				<Formik
					ref="form"
					initialValues={initialValues}
					validationSchema={validationSchema}
					onSubmit={this.onSubmit}
					render={props => {
						const {
							setFieldValue,
							setFieldTouched,
							values,
							errors,
							submitCount,
							handleChange,
							handleBlur,
							onChange,
							onBlur,
							touched
						} = props

						return (
							<form noValidate onSubmit={props.handleSubmit}>
								<h3 className="orange semi-bold">Forma de pagamento</h3>
								<div className="payment-fields">
									<CreditCardFields
										noInstallments
										noSecurityCode
										setFieldValue={setFieldValue}
										setFieldTouched={setFieldTouched}
										values={values}
										errors={errors}
										touched={touched}
										submitCount={submitCount}
										handleChange={handleChange}
										handleBlur={handleBlur}
										onChange={onChange}
										onBlur={onBlur}
										source="add-card-modal"
									/>
								</div>
								<div>
									<p>Definir como cartão principal</p>
									<CheckboxToggleInput id="isMainCard" {...props} />
								</div>
								<ButtonContainerStyled>
									<Button primary type="submit">
										Confirmar
									</Button>
								</ButtonContainerStyled>
							</form>
						)
					}}
				/>
			</Modal>
		)
	}
}

const initialValues = {
	cardBrand: cardBrand.visa,
	cardPrintedName: '',
	cardNumber: '',
	cardMonthValidity: null,
	cardYearValidity: '',
	isMainCard: false
}

const validationSchema = Yup.object().shape({
	cardBrand: Yup.string().required('Informe a bandeira do cartão'),
	cardPrintedName: Yup.string().required('Informe o nome impresso no cartão'),
	cardNumber: Yup.string()
		.min(16, 'O número deve ter no mínimo 16 caracteres')
		.required('Informe o número do cartão'),
	cardMonthValidity: Yup.string().required('Informe o mês de validate'),
	cardYearValidity: Yup.string().required('Informe o ano de validade')
})

export default AddCardModalComponent
